module.exports = __webpack_public_path__ + "img/PatchNotesViewerTopOverlay2.6484d6ec.webp";